<div class="devo-pipeline-staff-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="staff()"></grid-content>
</div>